export const bezahlungsart = {
  fixgehalt: 'fixgehalt',
  stunden: 'stunden',
} as const;

export type Bezahlungsart = keyof typeof bezahlungsart;
